module.exports = __webpack_public_path__ + "static/img/download-icon.9a0aab50.svg";